import type React from 'react';
import { useEffect, useState } from 'react';

import { ReachGoalStep } from './components/ReachGoalStep';
import { SetGoalStep } from './components/SetGoalStep';

const STEPS = {
	SetGoal: 'SET_GOAL',
	ReachGoal: 'REACH_GOAL',
} as const;
type Step = (typeof STEPS)[keyof typeof STEPS];

export const SharingGoalFlow: React.FC = () => {
	const [step, setStep] = useState<Step>(STEPS.SetGoal);

	useEffect(() => {
		window.scrollTo({ top: 0, behavior: 'smooth' });
	}, [step]);

	return step === STEPS.SetGoal ? <SetGoalStep onNext={() => setStep(STEPS.ReachGoal)} /> : <ReachGoalStep />;
};
